module.exports = __webpack_public_path__ + "img/Chinese Poker 6 Cards.307055f3.png";